import { PortalPagesService } from 'ag-common-svc/lib/services/portal-pages.service';
import { TemplatesService } from 'ag-common-svc/lib/services/templates.service';
import { Injectable, signal } from '@angular/core';
import { combineLatest, map } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { cloneDeep, groupBy, orderBy } from 'lodash';
import { TemplateKeys } from 'ag-common-svc/lib/components/administration/template-builder/template-editor-page/models';
import { BaseModelKeys } from '@ag-common-lib/lib/models/base.model';

@Injectable({
  providedIn: 'root',
})
export class PortalPagesDataService {
  private _groupedPortalPagesSig = signal<any[]>([]);
  groupedPortalPagesSig = this._groupedPortalPagesSig.asReadonly();

  constructor(
    private portalPagesService: PortalPagesService,
    private templatesService: TemplatesService,
  ) {
    combineLatest({
      portalPages: this.portalPagesService.getPortalPagesList(),
      templatePages: this.templatesService.getTemplatePagesList(),
    })
      .pipe(
        map(({ portalPages, templatePages }) => {
        const rootParentId = 'Root';
        const groupedByParentId = groupBy(portalPages, 'parentId');

        const usedNavigatorLinks = new Set<string>(
          (portalPages ?? [])
            .filter(item => item?.type !== 'folder')
            .map(item => item?.link)
            .filter(Boolean),
        );
        const additionalPagesItems = (templatePages ?? [])
          .map(tpl => {
            const label = tpl?.[TemplateKeys.name]?.toString()?.trim() ?? '';
            const dbId = tpl?.[BaseModelKeys.dbId];
            const link = dbId ? `/pages/dynamic/${dbId}` : null;
            return { label, link };
          })
          .filter(item => !!item?.label && !!item?.link && !usedNavigatorLinks.has(item.link));

        const groupedArray = Object.entries(groupedByParentId).map(([parentId, items]) => {
          const parentPage = portalPages.find(p => p.dbId === parentId);
          const key = parentPage ? parentPage.label.trim() : parentId === rootParentId ? '' : '';
          const filteredItems = items.filter(item => item.type !== 'folder').map(({ icon, ...rest }) => rest);
          return {
            key,
            items: orderBy(filteredItems, [items => (items.label ?? '').toString().toLowerCase()], ['asc']),
          };
        });

        if (additionalPagesItems?.length) {
          groupedArray.push({
            key: 'Additional Pages',
            items: orderBy(additionalPagesItems, [items => (items.label ?? '').toString().toLowerCase()], ['asc']),
          });
        }

          const sortedGroups = orderBy(groupedArray, [group => (group?.key ?? '').toString().toLowerCase()], ['asc']);
          this._groupedPortalPagesSig.set(cloneDeep(sortedGroups));
        }),
        shareReplay(1),
      )
      .subscribe();
  }
}
